import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-meta',
  templateUrl: './meta.component.html',
  styleUrls: ['./meta.component.styl'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MetaComponent implements OnInit {
  @Input() title = '';
  @Input() description = '';
  @Input() keywords = '';

  constructor(
    private titleService: Title,
    private metaService: Meta,
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle(this.title);

    this.metaService.updateTag({
      name: 'description',
      content: this.description,
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: this.keywords,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/meta/meta.component.ts